import { Component, OnInit, Input, inject, DestroyRef, OnChanges, SimpleChanges, ViewChild, effect } from '@angular/core';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash'
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScoreWidgetComponent } from '../../../../shared/components/score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { LtmsLineChartViewComponent } from '../../../../shared/components/graph/ltms-line-chart-view/ltms-line-chart-view.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
@Component({
    selector: 'app-action-ageing-actionable-issue-trend-chart',
    templateUrl: './action-ageing-actionable-issue-trend-chart.component.html',
    styleUrls: ['./action-ageing-actionable-issue-trend-chart.component.scss'],
    imports: [ScoreWidgetComponent, NgIf, LtmsLineChartViewComponent, LtmsErrorComponent, LtmsLoaderComponent]
})
export class ActionAgeingActionableIssueTrendChartComponent implements OnInit, OnChanges {
  @Input() componentId: string = ""
  @Input() filters: any = [];
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;
  destroyRef = inject(DestroyRef);
  isDateRangeChange: boolean = false;
  upperChartName: string = 'Trend - ';
  upperChartDiscription: string = 'Line chart showing the average age (in hours) of open actionable issues over time, highlighting how long issues remain unresolved.';
  projectId: string = '';
  fromDate: string = '';
  toDate: string = '';
  errorCode: string = '404';
  exportsData: any = [];
  isDataAvailable: boolean = false;
  brandDetails: any = {}
  universalFilter: any = {}
  hierarchStack: any = [];
  isDataLoaded: boolean = false;
  date_filter_type: number = 1;
  date_filter_field: string = "created_date";
  isRequestDate: any = '';
  chartId: string = "line-chart-" + this.getTimeStamp();
  chartStaticId: string = 'ltms-ageing-trend-chart'
  selectedTrendType: any = {}
  isFullScreen: boolean = false;
  accountDetails: any = {};
  downloadReportHeader: any = [];

  scoreWidget(): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: true
    };
  }
  widgetConfig: any = {
    "elementId": "ltms-widget-" + this.getTimeStamp(),
    "trendSelector": true,
    "viewSelector": {
      enable: false,
      type: 'chart'
    },
    "download": {
      enable: true,
      componentId: this.chartStaticId,
      data: {        
        "fileName": '',
        "title": '',
        "columns": [
          {
            order: 1,
            header: "Date",
            dataKey: "time",
          },
          {
            order: 2,
            header: "Average Age(Hrs)",
            dataKey: "age"
          }
        ],
        "rows": []
      }
    },
    "fullscreen": {
      enable: true,
      componentId: this.componentId
    }
  }
  xAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap"
      },
      "color": "#7f7f7f"
    }
  }
  yAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap",
      },
      "color": "#7f7f7f"
    },
    "min_y": 0,
    "max_y": 5
  }
  chartData: any = {
    chart: {
      title: '',
      ymin: 1,
      xmin: 1,
      description: '',
      trendType: 'Monthly',
      xValues: [],
      yValues: [],
      gradientColors: ["#301A4B", "#301A4B0F"],
      borderColor: '#301A4B',
      pointBorderColor: 'white',
      pointBackgroundColor: '#301A4B',
      pointHoverBackgroundColor: '#301A4B'
    },
    xAxis: {},
    yAxis: {},
  };
  constructor(
    private _actionService: ActionService,
    private _analytics: ResponseAnalyticsService,
    private route: ActivatedRoute,
    private globalFilterService: GlobalFilterService,
    private _helpers: HelpersService,
    private _appStateService: AppStateService
  ) {
      effect(()=>{
        if (this._appStateService.initialized()) {
          this.universalFilter = this._appStateService.universalFilter()
          this.hierarchStack = this._appStateService.hierarchyStack();
          const datePicker:any = this._appStateService.datePicker()
          this.isRequestDate = datePicker.isRequestDate
          this.getTrendsData(this.selectedTrendType);
        }
      })
      // Add event listeners for Escape key and click outside
      document.addEventListener('keydown', this.handleKeyDown.bind(this));
      document.addEventListener('click', this.handleClickOutside.bind(this));
    }

  ngOnInit(): void {
    this.widgetConfig = {
      "elementId": "ltms-widget-" + this.getTimeStamp(),
      "trendSelector": true,
      "viewSelector": {
        enable: false,
        type: 'chart'
      },
      "download": {
        enable: true,
        componentId: this.chartStaticId,
        data: {        
          "fileName": '',
          "title": '',
          "columns": [
            {
              order: 1,
              header: "Date",
              dataKey: "time",
            },
            {
              order: 2,
              header: "Average Age(Hrs)",
              dataKey: "age"
            }
          ],
          "rows": []
        }
      },
      "fullscreen": {
        enable: true,
        componentId: this.componentId
      },
    }
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state && !state.pending) {
        this.widgetConfig.elementId = "ltms-widget-" + this.getTimeStamp()
        this.upperChartName = (state.hierarchyStack) ? 'Average Age - Trend - ' + state.hierarchyStack[0].group_key[0] : 'Average Age - Trend - '+ state.brandDetails.name;
        this.projectId = state.brandDetails._id;
        this.fromDate = state.datePicker['startDate'];
        this.brandDetails = state.brandDetails
        this.accountDetails = state.accountDetails
        this.universalFilter = state.universalFilter ? state.universalFilter : {};
        this.hierarchStack = state.hierarchyStack;
        this.isDateRangeChange = true;
        this.toDate = state.datePicker['endDate'];
        this.date_filter_type = state.datePicker['dateFilterType'];
        this.isRequestDate = state.datePicker.isRequestDate
        // this.onTrendTypeChange(this.selectedTrendType)
      }
    })

  }

  // ngOnChanges() {
  //  // this.onTrendTypeChange(this.selectedTrendType)
  //   if (!_.isEmpty(this.filters)) {
  //     this.onTrendTypeChange(this.selectedTrendType, true)
  //   }
  // }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] && !_.isEmpty(this.filters) && _.has(this.filters, 'filters')) {
      this.onTrendTypeChange(this.selectedTrendType, true)
    }
  }

  onDownload() {
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      data: [{
        columns: this.downloadReportHeader,
        rows: this.exportsData
      }]
    }
    
    downloadConfig.fileDetails = {
      title: "Action Trend - Open Actionables " + this.selectedTrendType.name,
      fileName: "Action Trend - Open Actionables " + this.selectedTrendType.name,
      accountName: this.accountDetails.display_name || this.accountDetails.name,
      brandName: this.brandDetails.display_name || this.brandDetails.name
    }

    if (downloadConfig.data.length) {
      this._analytics.prepareAndDownloadData(downloadConfig);
    }
  }

  onFullScreen (event: any) {
    this.isFullScreen = event;
  }

    // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isFullScreen) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('ageing-trend-chart-component'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.isFullScreen && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  getTimeStamp() {
    return new Date().getTime()
  }

  onTrendTypeChange(trendType: any, drillDownEnabled:any) {
    if(this.isDateRangeChange || (trendType.trend_type != this.selectedTrendType.trend_type) || drillDownEnabled){
      this.selectedTrendType = trendType;
      this.getTrendsData(trendType);
      if (!_.isEmpty(this.filters) && !_.isEmpty(this.filters.filters) && this.filters.groupKeyAlias) {
        _.each(this.filters.filters, (filter) => {
          if (filter && filter.field_id == this.filters.groupKeyAlias) {
            this.upperChartName = 'Average Age - Trend - ' + filter.field_value
          } else {
            this.upperChartName = (this.hierarchStack && this.hierarchStack.length) ? 'Average Age - Trend - ' + this.hierarchStack[0].group_key[0] : 'Average Age - Trend - '+ this.brandDetails.name;
          }
        })
      } else {
        this.upperChartName = (this.hierarchStack && this.hierarchStack.length) ? 'Average Age - Trend - ' + this.hierarchStack[0].group_key[0] : 'Average Age - Trend - '+ this.brandDetails.name;
      }
      this.widgetConfig['download']['data']['fileName'] = "Action Trend - AGE" + " " + trendType.name
      this.widgetConfig['download']['data']['title'] = "Action Trend - AGE" + " - " + trendType.name
      this.isDateRangeChange = false;
    }
  }

  getExportsFields(trendType: string) {
    const fieldsToExport: any = [{
      header: "Date",
      dataKey: "time",
      type: "date",
      defaultValue: "",
      order: "1",
      trendType: trendType,
      addInTooltip: false,
      showPercentage: false,
      format: ""
    }, {
      header: "Total",
      dataKey: "total_count",
      addInTooltip: false,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "2",
      defaultValue: 0,
      format: ""
    }, {
      header: "Within TAT",
      dataKey: "within_tat",
      type: "number",
      order: "3",
      addInTooltip: false,
      showPercentage: true,
      totalKey: "total_count",
      defaultValue: 0,
      format: ""
    }, {
      header: "Missed TAT",
      dataKey: "outside_tat",
      addInTooltip: false,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "4",
      defaultValue: 0,
      display_format: ""
    }, {
      header: "Average Age(Hrs)",
      addInTooltip: true,
      showPercentage: false,
      dataKey: "age",
      order: "5",
      type: "number",
      defaultValue: 0,
      format: "round"
    }]
    return fieldsToExport
  }

  onChartClick(data: any) {
    const dateObject = data.dateRange
    dateObject.isCustomDateRangeSelected = true
    this._helpers.setDatePicker(data.dateRange)
  }

  getTrendsData(trendType?: any) {
    this.isDataLoaded = false;
    let params = this._actionService.getTrendsRequestParams({
      dateFilterField: this.isRequestDate ? "feedback_request_date" : "created_date",
      projectId: this.projectId,
      trendType: trendType.trend_type,
      action_type: "ageing",
      appliedfilters: _.get(this.filters, 'filters', [])
    })

    // let payload = this.getTrendsRequestParams()
    params.from = this.fromDate;
    params.to = this.toDate;
    params.brand_id = this.projectId;
    params.universal_filter = this.universalFilter;
    params.actionable_filter = _.get(this.brandDetails, "action_management_configuration.actionables", {});
    params.age_type = _.get(this.brandDetails, "action_management_configuration.ageing_config.type", 1);
    params.turnaround = _.get(this.brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);
    params.group_key_alias = _.get(this.filters, 'groupKeyAlias', 'brands');

    this._actionService.getTrendsData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response) => {
        if (response.code == 0 && response.data && response.data.response && !_.isEmpty(response.data.response)) {
          var trendData = response.data.response;
          const data = this._actionService.processTrendsData(trendData);
          const fieldsToExport = this.getExportsFields(trendType.name)
          this.exportsData = this._actionService.prepareDataForExport(trendData, fieldsToExport);
          this.chartData.chart.tooltipFields = fieldsToExport
          this.downloadReportHeader = fieldsToExport;
          this.chartData.chart.tooltipData = this.exportsData
          this.chartData.chart.title = data.accountsOrProjectsNames;
          this.chartData.chart.xValues = data.timestamp;
          this.chartData.chart.yValues = data.age;
          this.chartData.xAxis = this.xAxis;
          this.chartData.yAxis = this.yAxis;
          this.chartData.xAxis.title.text = this.isRequestDate ? "Request Date" : "Response Date";
          this.chartData.yAxis.title.text = "Average Age (Hours)"
          this.chartData.chart.trendType = trendType.name;
          this.chartId = "line-chart-" + this.getTimeStamp()
          this.widgetConfig.download.data.rows = this.exportsData;
          this.isDataAvailable = true;
          this.isDataLoaded = true;
        }
        else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }
}
